import React from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

interface LeadAllocationFiltersProps {
  filterFromDate: Date | undefined;
  filterToDate: Date | undefined;
  filterTeamMember: number | null;
  filterTeamLead: number | null;
  showTeamLeadFilter: boolean;
  showTeamMemberFilter: boolean;
  teamLeadOptions: { label: string; value: number }[];
  teamMemberOptions: { label: string; value: number }[];
  onFromDateChange: (date: Date | undefined) => void;
  onToDateChange: (date: Date | undefined) => void;
  onTeamMemberChange: (id: number | null) => void;
  onTeamLeadChange: (id: number | null) => void;
  onClear: () => void;
}

export const LeadAllocationFilters: React.FC<LeadAllocationFiltersProps> = ({
  filterFromDate,
  filterToDate,
  filterTeamMember,
  filterTeamLead,
  showTeamLeadFilter,
  showTeamMemberFilter,
  teamLeadOptions,
  teamMemberOptions,
  onFromDateChange,
  onToDateChange,
  onTeamMemberChange,
  onTeamLeadChange,
  onClear,
}) => {
  return (
    <div className="col-12 mb-3">
      <Accordion activeIndex={0}>
        <AccordionTab header="Filter">
          <div className="p-fluid grid formgrid">
            {/* From Date */}
            <div className="field col-12 md:col-3">
              <label htmlFor="fromDate" className="font-semibold">From Date</label>
              <Calendar
                id="fromDate"
                value={filterFromDate}
                onChange={(e) => onFromDateChange(e.value as Date | undefined)}
                dateFormat="dd/mm/yy"
                showIcon
                maxDate={new Date()}
                placeholder="Select From Date"
              />
            </div>

            {/* To Date */}
            <div className="field col-12 md:col-3">
              <label htmlFor="toDate" className="font-semibold">To Date</label>
              <Calendar
                id="toDate"
                value={filterToDate}
                onChange={(e) => onToDateChange(e.value as Date | undefined)}
                dateFormat="dd/mm/yy"
                showIcon
                minDate={filterFromDate || undefined}
                maxDate={new Date()}
                placeholder="Select To Date"
              />
            </div>

            {/* Team Lead Dropdown */}
            {showTeamLeadFilter && (
              <div className="field col-12 md:col-3">
                <label htmlFor="teamLead" className="font-semibold">Team Lead</label>
                <Dropdown
                  id="teamLead"
                  value={filterTeamLead}
                  options={teamLeadOptions}
                  onChange={(e) => onTeamLeadChange(e.value)}
                  placeholder="Select Team Lead"
                  showClear
                />
              </div>
            )}

            {/* Team Member Dropdown */}
            {showTeamMemberFilter && <div className="field col-12 md:col-3">
              <label htmlFor="teamMember" className="font-semibold">Team Member</label>
              <Dropdown
                id="teamMember"
                value={filterTeamMember}
                options={teamMemberOptions}
                onChange={(e) => onTeamMemberChange(e.value)}
                placeholder="Select Team Member"
                showClear
              />
            </div>}

            {/* Action Buttons */}
            <div className="col-12 flex justify-content-end gap-2 mt-3">
              <Button
                label="Clear"
                type="button"
                onClick={onClear}
                className="p-button-sm p-button-rounded p-button-outlined"
                style={{ width: "90px", height: "32px" }}
              />
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  );
};
